import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

import { IResponseMinimalCard } from '@interfaces/i-response-card-view-model';

@Component({
  selector: 'app-user-card-rows',
  templateUrl: './user-card-rows.component.html',
  styleUrls: ['./user-card-rows.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UserCardRowsComponent {

  @Input() userCards: IResponseMinimalCard[];
  @Input() cardSeleted: IResponseMinimalCard;
  @Input() classType: string = '';

  @Output() onCardSeleted: EventEmitter<IResponseMinimalCard> = new EventEmitter();
  tooltipText = 'Actualiza tus medios de pago desde Configuración.';
  constructor() { }

  public selectCard(card: IResponseMinimalCard): void {
    if(card.expired) { return; }
    this.onCardSeleted.emit(card);
  }

}
